import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueSplitter',
})
export class ValueSplitterPipe implements PipeTransform {
  transform(value: any, char: string, isfirst = true): string {
    if (!value) return '--';
    if (typeof value == 'number') value = Math.abs(value).toString();
    let [first, second] = value.split(char);
    if (isfirst) return first;

    return this.pad(Number(second), 2);
  }


  pad(num: number, size: number): string {
    if (isNaN(num))
      return "00";

    let s = num + "";
    while (s.length < size) s = s + "0";

    return s;
  }
}
